import { render, staticRenderFns } from "./VerPagina.vue?vue&type=template&id=09051c31&"
import script from "./VerPagina.vue?vue&type=script&lang=js&"
export * from "./VerPagina.vue?vue&type=script&lang=js&"
import style0 from "./VerPagina.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VerPagina.vue"
export default component.exports